
import { RunConfigService } from '@nuskin/ns-util';
import { loadLocalization } from '../utils/localize';

export const DEFAULT_COUNTRY = "US";
export const DEFAULT_LANGUAGE = "en";

export default function(localeApp) {
    return {
        props: {
            localeCountry: {
                type: String,
                default: '',
            },
            localeLanguage: {
                type: String,
                default: '',
            },
        },
        data: function() {
            return {
                localizedContent: () => ({}),
            };
        },
        computed: {
            /**
             * Returns the locale.
             */
            locale() {
                const { country, language } = RunConfigService.getRunConfig();
                const newCountry = this.localeCountry || country || DEFAULT_COUNTRY;
                const newLanguage = this.localeLanguage || language || DEFAULT_LANGUAGE;
                return `${newLanguage.toLowerCase()}_${newCountry.toUpperCase()}`;
            },
        },
        watch: {
            locale: {
                immediate: true,
                /**
                 * Loads the content for the locale this.locale.
                 */
                async handler () {
                    const content = await loadLocalization(localeApp, this.locale);
                    this.$set(this, 'localizedContent', content);
                },
            },
        },
        methods: {
            /**
             * Returns the translation for the specified key.
             * @param {String} key
             */
            translate(key) {
                return this.localizedContent[key] || '';
            },
        },
    };
}
